//商家管理
const PlatformMerchant = () => import(/*webpackChunkName:'sale'*/"@/page/sale/merchant/platformMerchant/platformMerchant.vue")
const YardMerchant =()=>import(/*webpackChunkName:'sale'*/"@/page/sale/merchant/yardMerchant/yardMerchant.vue")
const RouteTemp = () => import(/*webpackChunkName:'sale'*/'@/page/commons/routeTemp.vue')
export  const merchant=
    {
        path: '/main/merchant',
        name: '商家管理',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [{
            path: '/main/merchant/platform-merchant',
            name: '平台商家',
            meta: {
                requireAuth: true,
            },
            component: PlatformMerchant
        },
        {
            path: '/main/merchant/yard-merchant',
            name: '车场商家',
            meta: {
                requireAuth: true,
            },
            component: YardMerchant
        },
       ]
    }